const Eyebrow = ({ children, className = "" }) => (
    <p
        className={`flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-fog ${className}`}
    >
        <span className="h-1.5 w-1.5 rounded-full bg-brick" aria-hidden="true" />
        {children}
    </p>
);

export default Eyebrow;
